//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");
// require("./chartdata");
var stores = require("./albertsons3.geo.json");
var ich = require("./lib/icanhazjs/ICanHaz.min.js");


var templateFile = require("./popup.html");
ich.addTemplate("popup", templateFile);

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

 var geojsonMarkerOptions = {
    radius: 6
  };

  function getColor(d) {
  return d == 'acquired' ? '#f5891e' :
  d == 'original'  ? '#0083ca' :
  d == 'closing'  ? '#464646' :
  '#ffffff';
}

function getColor2(d) {
return d == 'acquired' ? '#ffffff' :
d == 'original'  ? '#ffffff' :
d == 'closing'  ? '#000000' :
'#ffffff';
}

  function style(feature) {
  return {
    color: getColor2(feature.properties.new_type),
    fillColor: getColor(feature.properties.new_type),
    weight: 1,
    opacity: 1,
    fillOpacity: 0.6
  };
}


  function onEachFeature(feature, layer) {
    layer.bindPopup(ich.popup({
    name: feature.properties.Banner,
    address: feature.properties.address,
    city: feature.properties.city
    // type: feature.properties.type2,
    // color: feature.properties.color
  }))
  }

var dots = L.geoJson(stores, {
    style: style,
    onEachFeature: onEachFeature,
    pointToLayer: function(feature, latlng) {
      return L.circleMarker(latlng, geojsonMarkerOptions);
    }
  }).addTo(map);

map.fitBounds(dots.getBounds());

// var layer = L.tileLayer('http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
//   attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
// });

// map.addLayer(layer);
